import { cn } from "@newxsystems/shared";
import type { IVelvetRichTextProps } from "./VelvetRichText.props";

export const VelvetRichText = ({ className, content }: IVelvetRichTextProps) => (
  <div
    className={cn(
      "font-velvet-body text-lg leading-[1.6] text-pretty text-foreground md:text-xl [&_a]:text-thread [&_a]:underline [&_a]:decoration-1 [&_a]:underline-offset-4 [&_blockquote]:border-y [&_blockquote]:border-plum [&_blockquote]:py-5 [&_blockquote]:font-velvet-display [&_blockquote]:text-2xl [&_blockquote]:font-bold [&_blockquote]:uppercase [&_blockquote]:leading-tight [&_blockquote]:text-smoke [&_li]:my-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_p+p]:mt-5 [&_strong]:font-bold [&_ul]:list-disc [&_ul]:pl-6",
      className,
    )}
    dangerouslySetInnerHTML={{ __html: content }}
  />
);

VelvetRichText.displayName = "Content::VelvetRichText";
